interface IProps {
    id: string;
    element: React.FC;
}

export class TooltipProperties {

    id: string;

    element: React.FC;

    constructor({ id, element }: IProps) {
        this.id = id;
        this.element = element;
    }
}